import { render } from "./BeneficiarioInicioComponent.vue?vue&type=template&id=79fba4c0&scoped=true"
import script from "./BeneficiarioInicioComponent.vue?vue&type=script&lang=js"
export * from "./BeneficiarioInicioComponent.vue?vue&type=script&lang=js"

import "./BeneficiarioInicioComponent.vue?vue&type=style&index=0&id=79fba4c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79fba4c0"]])

export default __exports__